import {classNames, observer, React} from '@api'
import {useWhiteboardStore} from '@modules/whiteboard'
import { WhiteboardHamburgerMenu, ZoomMenu2, PageMenu } from './'
import { Panel } from '~components/Panel'
import * as css from './TopPanel.css'

export const TopPanel = observer<{className?: string}>(function TopPanel({className}) {
  const {showMenu, showPages, showStyles, showZoom} = useWhiteboardStore()

  return (
    <div className={classNames(css.root, className)}>
      {(showMenu || showPages) && (
        <Panel side="left">
          <WhiteboardHamburgerMenu/>
          <PageMenu/>
        </Panel>
      )}
      <div className={css.spacer} />
      {(showStyles || showZoom) && (
        <Panel side="right">
          {/*<StyleMenu/>*/}
          <ZoomMenu2/>
        </Panel>
      )}
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/TopPanel/TopPanel.tsx